import {
    useCallback,
} from 'react'

import SkyNetTable from 'app/shared-components/SkyNetTable'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'

import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'

import requests from 'app/requests/Order/Order.requests'
import containerRequests from 'app/requests/Container/Container.requests'
import internalTransportsConfig from './internalTransports.config'
import customerTransportsConfig from './customerTransports.config'
import wrongPairingsConfig from './wrongPairings.config'
import useStyles from './ContainerSelection.style'

enum ContainerSelectionTables {
    PreconditioningFeasibility = 'preconditioningFeasibility',
    CustomerTransports = 'customerTransports',
    InternalTransports = 'internalTransports',
    WrongPairings = 'wrongPairings',
}

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const DOMAIN_NAME = 'ContainerSelectionView'

const ContainerSelection = () => {
    const {
        classes,
    } = useStyles()
    const OrderManagementRoutes = useOrderManagementRoutes()
    const ContainerManagementRoutes = useContainerManagementRoutes()

    const onRowClick = useCallback((name, {
        orderNumber,
        serialNumber,
    }) => {
        switch (name) {
        case ContainerSelectionTables.PreconditioningFeasibility:
        case ContainerSelectionTables.CustomerTransports:
        default:
            return OrderManagementRoutes.CustomerOrders.ContainerSelection.navigate({
                params: {
                    key: orderNumber,
                },
            })
        case ContainerSelectionTables.InternalTransports:
            return OrderManagementRoutes.InternalOrders.ContainerSelection.navigate({
                params: {
                    key: orderNumber,
                },
            })
        case ContainerSelectionTables.WrongPairings:
            return ContainerManagementRoutes.Containers.Overview.navigate({
                params: {
                    key: serialNumber,
                },
            })
        }
    }, [
        OrderManagementRoutes,
        ContainerManagementRoutes,
    ])

    return (
        <div className={classes.root}>
            <div className={classes.headerTitle}>Customer Transports</div>
            <div className={classes.tableWrapper}>
                <SkyNetTable
                    name={DOMAIN_NAME}
                    tableControls={tableControls}
                    onRowClick={(args) => {
                        onRowClick(ContainerSelectionTables.CustomerTransports, args)
                    }}
                    customUrl={requests.customerTransports()?.url}
                    tableConfig={customerTransportsConfig}
                    uniqField="orderNumber"
                    isShowCounterTab
                    paginationModeMatches
                    showSearch
                />
            </div>
            <div className={classes.headerTitle}>
                Internal Transports
            </div>
            <div className={classes.tableWrapper}>
                <SkyNetTable
                    name={DOMAIN_NAME}
                    tableControls={tableControls}
                    onRowClick={(args) => {
                        onRowClick(ContainerSelectionTables.InternalTransports, args)
                    }}
                    customUrl={requests.internalTransports()?.url}
                    tableConfig={internalTransportsConfig}
                    uniqField="orderNumber"
                    isShowCounterTab
                    paginationModeMatches
                    showSearch
                />
            </div>
            <div className={classes.headerTitle}>
                Container Monitoring
            </div>
            <div className={classes.tableWrapper}>
                <SkyNetTable
                    name="WrongPairings"
                    tableControls={tableControls}
                    onRowClick={(args) => {
                        onRowClick(ContainerSelectionTables.WrongPairings, args)
                    }}
                    customUrl={containerRequests.wrongPairings()?.url}
                    tableConfig={wrongPairingsConfig}
                    uniqField="serialNumber"
                    isShowCounterTab
                    paginationModeMatches
                    showSearch
                />
            </div>
        </div>
    )
}

export default ContainerSelection
